import {BoidAssignment} from "@common-core/coat-operational-hierarchy-appsync-model";
import {BoidAssignmentState, fromBoidAssignment} from "../model";

export type BoidAssignmentStatesInterceptor = (
  states: BoidAssignmentState[]
) => BoidAssignmentState[];

/**
 * This high-order function produces a mapping function that is capable of merging
 * the supplied {@link BoidAssignment} collection into an existing collection
 * of {@link BoidAssignmentState} objects used to track assigned and unassigned BOIDs.
 *
 * The only reason this exists is to handle the edge case where a {@link ClientEntity}
 * is unlinked from the {@link OperationalEntity} leaving an orphaned
 * {@link BoidAssignment}.
 *
 * @param assignments - Array of orphaned BoidAssignment objects from the operational entity
 * @returns Function that merges orphaned assignments into existing BoidAssignmentState array
 * @see {@link collectBoidAssignmentStatesFromClientEntities} for the initial collection of assignment states
 */
export const mergeOrphanedAssignmentsIntoStates = (
  assignments?: BoidAssignment[]
): BoidAssignmentStatesInterceptor => {
  return states => {
    const result = [...states];

    (assignments || []).forEach(assignment => {
      const existingStateIndex = result.findIndex(
        state =>
          state.type === assignment.businessOperationType.toUpperCase() &&
          state.id === assignment.businessOperationId
      );

      // If the assignment doesn't already exist in the states, add it
      if (existingStateIndex === -1) {
        result.push(fromBoidAssignment(assignment));
      }
    });

    return result;
  };
};
